<div class="row">
  <div
    class="col-12 relative"
    [ngClass]="components[0].flushed ? 'flushed' : 'no-flush'"
    [ngSwitch]="components[0].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="components[0]" style="width: 100%"></cta>
    <embed-url *ngSwitchCase="'embed'" [embed]="components[0]"></embed-url>
    <image-block *ngSwitchCase="'image'" [imgblock]="components[0]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="components[0]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="components[0]"
      [slideCount]="10"
      [dynamic]="true"
    ></showcase>
    <showcase
      *ngSwitchCase="'showcase-list'"
      [showcase]="components[0]"
      [slideCount]="10"
      [dynamic]="false"
    ></showcase>
    <showcase
      *ngSwitchCase="'popular-list'"
      [showcase]="components[0]"
      [slideCount]="10"
      [dynamic]="false"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="components[0]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="components[0]"></topic-search>
    <customer-care
      *ngSwitchCase="'customerCare'"
      [customerCareDetails]="components[0]"
    ></customer-care>
    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          title="Choose a Component"
          #select1
          class="form-control"
          (change)="openSideNav(select1.value, 0, components, 'col-1', false)"
        >
          <option value="0">--Choose--</option>
          <option
            *ngFor="let comps of editComponentList"
            [value]="comps.value"
            [title]="comps.height"
          >
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <ng-container *ngIf="components[0].typeOf">
      <div *ngIf="edit && components[0].typeOf !== 'edit'" class="edit-component text-center">
        <div class="edit-existing">
          <a
            tabindex="0"
            (click)="openSideNav(components[0].typeOf, 0, components, 'col-1', true)"
            (keyup.enter)="openSideNav(components[0].typeOf, 0, components, 'col-1', true)"
            >Edit Component</a
          >
          <ng-container *ngIf="components[0].typeOf !== 'customerCare'">
            <div class="edit-or">- OR -</div>
            <select
              title="Choose New Component"
              #select1
              class="form-control"
              (change)="openSideNav(select1.value, 0, components, 'col-1', false)"
            >
              <option value="0">--Choose New--</option>
              <option
                *ngFor="let comps of editComponentList"
                [value]="comps.value"
                [title]="comps.height"
              >
                {{ comps.name }}
              </option>
            </select>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
